import { Component, Input, OnInit } from '@angular/core';
import { TYPE_SECTIONS } from 'app/core/models/constans.model';
import { Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';
import { PreloadImgComponent } from './../../../core/directives/preload-img/preload-img.component';
@Component({
    selector: 'app-menu-infiniti-scroll',
    templateUrl: './menu-infiniti-scroll.component.html',
    styleUrls: ['./menu-infiniti-scroll.component.scss'],
    standalone: false
})
export class MenuInfinitiScrollComponent extends PreloadImgComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  /**
   * Tipos de secciones
   */
  readonly TYPE_SECTIONS = TYPE_SECTIONS;
  constructor(
    public menuService: MenuService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }

  setBackground(section: SectionMenu): string {
    if (this.menu.shapeColor === 'noInvert' || section.isSeparator) {
      return this.menu.color;
    }
    return this.menu.colorText;
  }

  setColorText(section: SectionMenu): string {
    if (this.menu.shapeColor === 'noInvert' || section.isSeparator) {
      return this.menu.colorText;
    }
    return this.menu.color;
  }


}
